<template lang="pug">
    v-card
        model-data-table(
            :filters='filters'
            :service='service' 
            :headers='headers'
            no-data-text="Sin finiquitos."
            :no-detail="!$can('VIEW_DETAIL_FINIQUITO')"
            :no-remove="!$can('DELETE_FINIQUITO')"
            no-search
            remind-key='finiquito-list'
            @remove="deleteContract($event.item.id)"
            @detail="submitShow($event.item.id)"
        )
            //template( slot="actions" slot-scope="props" )
                v-btn-action( 
                    v-if="$can('DELETE_FINIQUITO')"
                    @click="deleteMsgFiniquito( props.item )" 
                    color="error darken-2"
                    :disabled="props.item.hr_finiquito_status.status === 'Sin Autorizar'"
                    tooltip="Eliminar" 
                )
                    v-icon cancel
        crud-create-button(
            text="Crear Finiquito"
            :action="() => $router.push('/finiquitos/create')"
            v-if="$can('CREATE_FINIQUITO')"
            )
</template>

<script>
/* components */
import {
    CrudDataTable,
    DTService,
    CrudCreateButton,
} from '@/components/reusable_components'
/* vuex */
import { mapActions, mapState } from 'vuex'
/* header for table */
import Headers from './tableListHeader'
/* model */
import finiquitoMdl from '@/models/HumanResource/HRFiniquito'
/* services */
import FiniquitoService from '@/services/api/finiquito'
//
import { ModelDataTable, VBtnAction } from '@/components/reusable_components/next'
import FiniquitoModel from '@/models/HumanResource/HRFiniquito'
import FiniquitoFilters from '@/views/HumanResource/HrFiniquito/HrFiniquitoFilters'
//
export default {
    name: 'finiquito-list',
    data: function() {
        return {
            filters: FiniquitoFilters,
            service: FiniquitoModel,
            headers: Headers,
            finiquitoDeleteId: null,
        }
    },
    computed: {
        /**
         *
         */
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        // -- UI Modification
        // -- Data fetching
        /**
         *
         */
        fetchFiniquitoData() {
            let arrIncludes = [
                'hr_finiquito_status',
                'g_user.hr_employee',
                'hr_employee',
            ]

            let model = finiquitoMdl.include(arrIncludes)
            this.service.dtFetchData = DTService.generateFetchDataFunction(
                model,
                [],
                []
            )
        },
        // -- Data handling and transformations
        // -- Validations and Error handling
        // -- Other functions
        deleteMsgFiniquito(item) {
            this.setDeleteFiniquitoId(item.id)
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Eliminar')
            this.initSnackbar(
                this.fillSnack(
                    'warning',
                    'Eliminar Finiquito',
                    '¿Estas seguro de querer Eliminar el finiquito seleccionado?'
                )
            )
        },
        submitShow(finiquitoId) {
            this.redirectTo(`/finiquitos/${finiquitoId}`)
        },
        redirectTo(route) {
            this.$router.push(route)
        },
        async submitDelete() {
            const id = this.getDeleteFiniquitoId()
            let resp = await FiniquitoService.deleteFiniquito(id)
            this.snackResponseSubmit(resp, 'Eliminado', '/finiquitos')
            this.fetchFiniquitoData()
        },
        setDeleteFiniquitoId(id) {
            this.finiquitoDeleteId = id
        },
        getDeleteFiniquitoId() {
            return this.finiquitoDeleteId
        },
        snackResponseSubmit(response, actionDone, redirectRoute) {
            if (response.status === 'success' || response.status === 200) {
                const msg = `Finiquito ${actionDone} exitosamente`
                this.successMessage(msg)
                this.redirectTo(redirectRoute)
                //this.redirectTo(`/finiquitos/${finiquitoId}`)
            } else this.errorMessage(response)
        },
        /**
         *
         */
        successMessage(message) {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack('success', 'Éxito', message, false, 5000)
            )
        },
        /**
         *
         */
        errorMessage(response) {
            this.resetSnackbarState()
            if (response.error)
                this.initSnackbar(
                    this.fillSnack(
                        'error',
                        'Error',
                        response.error,
                        false,
                        5000
                    )
                )
            else
                this.initSnackbar(
                    this.fillSnack(
                        'error',
                        'Error',
                        'Ha ocurrido un error al enviar los datos al servidor',
                        false,
                        5000
                    )
                )
        },
        /**
         *
         */
        redirectTo(route) {
            this.$router.push(route)
        },
        // -- Vuex mappings
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        responseConfirm(val) {
            switch (val) {
                case 'Eliminar':
                    this.submitDelete()
                    break

                default:
                    break
            }
        },
    },
    components: {
        CrudDataTable,
        CrudCreateButton,
        ModelDataTable,
        VBtnAction,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    beforeMount() {
        this.setTitleTopBar('Finiquitos')
        this.fetchFiniquitoData()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_FINIQUITO')) ctx.$router.push('/')
        })
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>